export const ADMIN_ROLE_ID=1;